import { BaseAPIClient } from '@mi-front/core';

export const FragmentsAPI = {
  configUpdate(this: BaseAPIClient, stationId: string, data: unknown) {
    return this.put(`/fragments/config/${stationId}`, data);
  },
};
